namespace Gordic.Epk.WebControls {

    const { gcontent } = Decorators;

    @gcontent
    export class GEpkVlastniZadosti extends GContentBase {

        private grid: JQuery<HTMLElement>;
        private view: Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>;
        private Rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[];

        /** uživatelský požadavek na přerušení hromadného vyřízení */
        private userRequestedCancel: boolean;
        /** text uživatelského požadavku na přerušení hromadného vyřízení */
        private userRequestedCancelText: string;
        /** progres operace vyřízení jednoho souboru v hromadném vyřízení */
        private progress: number;
        /** zbývající počet */
        private remains: number;
        /** index žádosti, která se právě vyřizuje  */
        private index: number;
        /** úspěšně vyřízené */
        private success: number;
        /** neúspěšně vyřízené */
        private fail: number;

        public onContentReady() {
            this.init();
        }

        private init() {
            this.createGrid();
            this.createCommandbar();
        }

        private initValues() {
            this.success = 0;
            this.fail = 0;
            this.remains = this.Rows.length;
            this.index = 0;
            this.progress = 0;
            this.userRequestedCancel = false;
            this.userRequestedCancelText = "jres:32000242"; //RC 32000242 : Bylo zahájeno zrušení hromadné operace.
        }

        private createGrid() {

            this.view = new Data.View(this.Rows);

            this.grid = $("<div>").gautofit().appendTo(this.element);
            var format = this.getFormat();
            var searchColumns = this.searchColumns(format)

            this.grid.ggrid({
                data: this.view,
                name: "gridVlastiZadosti",
                renderMode: "auto",
                columnMode: "full",
                customClass: "epk-vlastnizadosti-grid",
                navigationMode: "row",
                columns: format,
                sort: "!dat_vyrizeni",
                searchColumns: searchColumns,
            });

        }

        private getFormat() {

            var format = new Gordic.Data.GridFormat();
            var gf = new GEpkGridFormatColumnsInternal();


            format
                .addIconColumn({
                    name: "stav_zrusit",
                    caption: "jres:32000816", //RC 32000816 : Stav zrušení
                    iconTemplate: (data) => {
                        //#region -- iconTemplate --

                        var template: IconTemplate = { icon: "", tooltip: "" };
                        if (data["state_zrusit"] === true) {        // success
                            template.icon = "fa-check-circle g-state-text g-state-success";
                        }
                        else if (data["state_zrusit"] === false) {  // fail
                            template.icon = "fa-times-circle g-state-text g-state-error";
                        }
                        template.tooltip = data["state_zrusit_tooltip"] == null ? "" : data["state_zrusit_tooltip"];

                        return template;

                        //#endregion
                    }
                })

            gf.getIxp(format);
            gf.getTermin(format);
            gf.getFunKomu(format);
            gf.getTypPozadPodTxt(format);
            gf.getNavaznost(format);
            gf.getVec(format);
            gf.getVecSpis(format);
            gf.getFunOdNazev(format);
            gf.getDatPozad(format);
            gf.getNazevFunAkt(format);
            gf.getNazevSuAkt(format);

            return format;
        }

        private searchColumns(format: Gordic.Data.GridFormat) {
            /** sloupce na prohledávání */
            var searchColumns = [] as string[];
            for (var index = 0; index < format.columns.length; index++) {
                var columns = format.columns[index];
                if (columns.name !== undefined) {
                    searchColumns.push(columns.name);
                }
            }
            return searchColumns;
        }

        private createCommandbar() {

            var params: MenuParams[] = [];

            params.push({
                favorite: true,
                action: new GAction({
                    name: "actClose",
                    caption: "jres:32000822", //RC 32000822 : Zavřít
                    run: () => {
                        this.tryClose();
                    }
                })
            });

            params.push({
                primary: true,
                favorite: true,
                action: this.actions.add(new GAction({
                    name: "actZrusit",
                    caption: "jres:32000823", //RC 32000823 : Zrušit žádosti
                    run: () => {
                        this.initValues();
                        this.runAction();
                    }
                }))
            });
            this.commandBar(params);
        }

        //#region -- ZRUŠENÍ VLASTNÍCH ŽÁDOSTÍ --

        private runAction() {
            this.beginOperation();
            this.settlement(this.Rows);
        }

        private settlement(list: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {

            $.Deferred().resolve()
                .then(() => {
                    var item = list[this.index];
                    this.runOperation(false, { ixp: item.ixp!, success: this.success, fail: this.fail, remains: this.remains, progressText: "jres:32000818" }, { progress: ++this.progress }); //RC 32000818 : Probíhá zrušení žádosti
                    return this.isUserRequestedCancel();
                })
                .then(() => {
                    var item = list[this.index];
                    return this.zrusitZadostdoEPK(item);
                })
                .done((opt: { State: boolean, Message: string }) => {
                    var item = list[this.index];
                    // konec předchozí operace
                    this.endOperation();
                    this.gridChange(item, opt);
                    if (this.index === (list.length - 1)) {
                        // zvýšení indexu posledního vyřízeného souboru
                        this.success++;
                        this.showResult();
                    }
                    // posuneme se na vyřízení dalšího souboru
                    else {
                        this.success++;
                        this.shiftToVyrizNextFile(list);
                    }
                })
                .fail((reason: IGReasonResponse, userRequestCancel: boolean) => {
                    Gordic.Gui.WebApp.Utils.showReasonFlash(this, reason);
                    // konec předchozí operace
                    this.endOperation();
                    // uživatelské přerušení hromadného vyřízení
                    if (userRequestCancel === true) {
                        this.showResult();
                    }
                    else {
                        var item = list[this.index];
                        if (reason != null) {
                            this.gridChange(item, { State: false, Message: reason.reason });
                            this._fail(list);
                        }
                        else {
                            console.error("Při hromadném vyřízení nastala chyba.");
                            this.showResult();
                        }
                    }
                })

        }

        private zrusitZadostdoEPK(item: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            var dfd = $.Deferred();
            this.call("ZrusitZadostdoEPK", { Ixp: item.ixp, SerCislo: item.ser_cislo })
                .then((opt: { State: boolean, Message: string }) => {
                    dfd.resolve(opt);
                })
                .fail((reason) => {
                    var responseText = handleException(reason, "EpkCancelOwnRequest");
                    var rejectReason: IGReasonResponse = {
                        reason: responseText,
                        handled: true,
                        type: EReasonType.serverError,
                        operation: OperationsEnum.sign
                    }
                    dfd.reject(rejectReason);
                })
            return dfd.promise();
        }

        private gridChange(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, opt: { State: boolean, Message: string }) {
            var rows = this.view.getDataRows();
            for (var index = 0; index < rows.length; index++) {
                if (rows[index].ixp === row.ixp && rows[index].ser_cislo === row.ser_cislo) {   // najdu správnou žádost
                    rows[index]["state_zrusit"] = opt.State;
                    rows[index]["state_zrusit_tooltip"] = opt.Message;

                    if (opt.State === false)
                        this.fail++;

                    this.view.updateData(rows);
                }
            }
        }

        /**
         * posunutí na další žádost
         */
        private shiftToVyrizNextFile(list: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            // posunutí na další soubor k vyřízení
            this.index++;
            // zvýšení hodnoty úspěchu (success) + 1
            // snížení počtu souborů (remains) - 1
            this.progress = 0;
            var item = list[this.index];
            this.runOperation(true, { ixp: item.ixp!, success: this.success, fail: this.fail, remains: --this.remains, progressText: "jres:32000237" }, { total: 3, progress: this.progress }); //RC 32000237 : Probíhá inicializace
            this.settlement(list);
        }

        /**
         * ukaž výsledek hromadné operace
         */
        private showResult() {
            // uživatelské přerušení hromadných operací
            if (this.userRequestedCancel == true)
                this.showFlash({ id: "id-flash-user-request-cancel", content: "jres:32000819", state: "warning" }); //RC 32000819 : Operace byla přerušena.
            else {
                if (this.fail > 0)
                    this.showFlash({ id: "id-flash-result", content: "jres:32000820", state: "error" }); //RC 32000820 : Některé žádosti se nepovedlo zrušit.
                else 
                    this.showFlash({ id: "id-flash-result", content: "jres:32000821", state: "success" }); //RC 32000821 : Zrušení žádostí bylo úspěšně dokončeno.
            }
            // po dokončení akce zablokovat tlačítko pro opakované použití
            if (this.actions.actZrusit != null)
                this.actions.actZrusit.enabled(false);
        }

        private _fail(list: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            // failnutá žádost je zároveň poslední -> ukončíme hromadnou operaci
            if (this.index === (list.length - 1)) {
                this.fail++;
                this.showResult();
            }
            else {
                this.fail++;
                this.shiftToVyrizNextFile(list);
            }
        }

        private isUserRequestedCancel(customDto?: any) {
            var dfd = $.Deferred();
            if (this.userRequestedCancel === true) {
                var obj: IGReasonResponse = { reason: "jres:32000487", handled: false, type: EReasonType.userCancelled, operation: OperationsEnum.sign }; //RC 32000487 : Přerušeno uživatelem.
                dfd.reject(obj, true);
            }
            else {
                dfd.resolve(customDto);
            }
            return dfd.promise();
        }

        /**
        * spustit operaci (gcover)
        */
        private runOperation(begin: boolean, value: IOperationCoverValue, counter: IOperationCoverCounter): void {

            if (this.userRequestedCancel) {
                //#region text přerušení operace
                var text = this.userRequestedCancelText;
                //#endregion
            }
            else {

                //#region text operace

                var text = value.progressText + " - <b>" + value.ixp + "</b>" + "<br>";
                text += "<p><b style='color: green'>" + value.success + "</b>/";
                text += "<b style='color: red'>" + value.fail + "</b>";
                text += "<b> zbývá " + value.remains + " </b></p>";

                //#endregion
            }

            //#region beginOperation
            if (begin && (counter.total != null)) {
                this.beginOperation({
                    text: text,
                    total: counter.total,
                    progress: counter.progress,
                    cancelAction: new GAction({
                        name: "btnAction",
                        caption: "jres:32000024",			//RC 32000024 : Zrušit
                        run: (ev, ctx) => {
                            this.userRequestedCancel = true;
                            this.progressOperation(this.userRequestedCancelText, this.progress);
                        }
                    })
                });
            }
            //#endregion

            //#region progressOperation
            else {
                this.progressOperation(text, counter.progress);
            }
            //#endregion
        }

        //#endregion

    }

}